import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import WikiSidebarToggle from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sidebar_toggle.vue?vue3';
export default {
    name: 'WikiSidebarHeader',
    components: {
        WikiSidebarToggle,
        GlButton
    },
    inject: [
        'hasCustomSidebar',
        'editSidebarUrl',
        'canCreate',
        'isEditingSidebar'
    ],
    props: {
        pagesListExpanded: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'toggle-pages-list'
    ],
    computed: {
        headerClasses () {
            return {
                'wiki-list gl-pl-0': this.hasCustomSidebar
            };
        },
        editCustomSidebarButtonLabel () {
            return this.hasCustomSidebar ? s__('Wiki|Edit custom sidebar') : s__('Wiki|Add custom sidebar');
        }
    },
    methods: {
        onWikiSidebarButtonClick () {
            if (!this.hasCustomSidebar) return;
            this.$emit('toggle-pages-list');
        }
    }
};
